import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/record-details")({
    component: RecordDetailsRoute,
});

function RecordDetailsRoute() {
    return <Outlet />;
}
